var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#2D2F36",
    rx: 15.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#close-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2D2F36",
    d: "M20.95 20.125 16.825 16l4.125-4.125a.583.583 0 0 0 0-.825.583.583 0 0 0-.825 0L16 15.175l-4.125-4.125a.583.583 0 0 0-.825 0 .583.583 0 0 0 0 .825L15.175 16l-4.125 4.125a.583.583 0 1 0 .825.825L16 16.825l4.125 4.125a.583.583 0 1 0 .825-.825"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "close-circle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16 6.1 9.9 9.9-9.9 9.9L6.1 16z"
  })))));
};
export default SvgCloseCircle;